import { useContext } from 'react';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { Feature } from 'src/WebApiController';
import { useContext as useContextWithSelector } from 'use-context-selector';

import {
  catalogMetricsContextWithSelector,
  createCatalogMetricsContextV2,
} from './CatalogMetrics.type';

/**
 * @deprecated use the explicit context selectors to avoid unnecessary re-render
 */
export function useCatalogMetricsContext<
  TMetrics extends { currency: string | null },
>() {
  const hasCatalogDataContextWithSelectorFeature = useUserHasFeature(
    Feature.FEPerf_CatalogDataContextWithSelector
  );

  // Consignors use the same V2 context as regular users; the backend already
  // aggregates metrics across all consignees.
  const context = useContext(createCatalogMetricsContextV2<TMetrics>());

  const contextWithSelector = useContextWithSelector(
    catalogMetricsContextWithSelector<TMetrics>()
  );

  return hasCatalogDataContextWithSelectorFeature
    ? contextWithSelector
    : context;
}
